import PhishingIcon from '../../../Layout/Components/PhishingIcon';
import React, {Fragment} from "react";
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Row, Col, Card, CardBody, CardTitle, Input, Button, Spinner, Alert, Nav, NavItem, NavLink } from 'reactstrap';

import PageTitle from '../../../Layout/Components/PageTitle';
import { withTranslation } from 'react-i18next';
import EmailTemplateModal from './EmailTemplateModal';
import EmailTemplateTable from './EmailTemplateTable';
import { toast } from 'react-toastify';
import classnames from 'classnames';
import {getEmailTemplateList, getEmailTemplate, deleteEmailTemplate} from "../../../API/PhishingAPI.js";
import {etReactTableConfiguration_ForTemplateScreen, etReactTableConfiguration_ForImportScreen} from './ETColumnGenerator'
import PhishingDataTable from '../PhishingDataTable'
import TemplateGallery from '../TemplateGallery/TemplateGallery';

export class EmailTemplate extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      openEdit: false,
      emailTemplateList:[],
      isLoaded: false,
      emailTemplate: {},
      error:false,
      errorFetchingData: "",
      activeTab: 1,
      datasets:{
        1:{
          data: null,
          dataFetchFunc: getEmailTemplateList,
          config: etReactTableConfiguration_ForTemplateScreen
        },
        2:{
          data: null,
          dataFetchFunc: () => getEmailTemplateList({domain: "0.template"}),
          config: etReactTableConfiguration_ForImportScreen
        }
      }
    }

    this.loadEmailTemplateList = this.loadEmailTemplateList.bind(this);
    this.onSubmitCallback = this.onSubmitCallback.bind(this);
    this.deleteEmailTemplate = this.deleteEmailTemplate.bind(this);
    this.addPolicyCallback = this.addPolicyCallback.bind(this);
    this.onEditOrCopyCallback = this.onEditOrCopyCallback.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.setDataForActiveTab = this.setDataForActiveTab.bind(this);
  }

  componentDidMount() {
    this.loadEmailTemplateList('1');
    // Warm the small shared catalog while the user views their own templates.
    this.loadEmailTemplateList('2');
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  onSubmitCallback(){
    this.loadEmailTemplateList('1');
  }

  async onEditOrCopyCallback(item, copiedVersion) {
    if (this.loadingDetail) return;
    this.loadingDetail = true;
    try {
      const content = String(this.state.activeTab) === '2'
        ? await getEmailTemplate(item.id, {domain: '0.template'}) : item;
      if (!this.unmounted) this.setState({
        openEdit: true,
        emailTemplate: content,
        copiedVersion
      });
    } catch (error) {
      toast.error('Error loading template');
    } finally {
      this.loadingDetail = false;
    }
  }

  loadEmailTemplateList(tab = String(this.state.activeTab)) {
    const dataset = this.state.datasets[tab];
    if (this.pendingLoads?.[tab]) return this.pendingLoads[tab];
    this.pendingLoads = this.pendingLoads || {};
    this.setState(updater => ({
      datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], loading: true, error: null}}
    }));
    const request = dataset.dataFetchFunc().then(items => {
      const data = items.map(item => ({...item,
        modified_date: new Date(item.modified_date).toLocaleString(undefined, {dateStyle:'full', timeStyle:'medium'})
      }));
      if (!this.unmounted) this.setState(updater => ({
        datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], data, loading: false}}
      }));
    }).catch(error => {
      if (!this.unmounted) this.setState(updater => ({
        datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], loading: false, error: 'Error fetching data'}}
      }));
    }).finally(() => { delete this.pendingLoads[tab]; });
    this.pendingLoads[tab] = request;
    return request;
  }

  deleteEmailTemplate(e){
    const id = e._original.id;
    deleteEmailTemplate(id)
      .then(res => {
        this.setDataForActiveTab();
        this.toggleTab(1);
      }).catch(error => {
        toast["error"](this.props.t("deleting", { element: 'Email Template', message: error.message }));
      })
  }
  addPolicyCallback(){
    const {activeTab} = this.state;
    this.setState(updater => ({
      openEdit: false,
      emailTemplate: {}
    }), () => {
      this.toggleTab(1);
    });
  }

  setDataForActiveTab(data) {
    const tab = String(this.state.activeTab);
    this.setState(updater => ({
      datasets: {...updater.datasets, [tab]: {...updater.datasets[tab], data}}
    }));
  }
  render(){
    const { t, i18n } = this.props;
    const editEmailTemplate = this.state.openEdit &&
      <EmailTemplateModal open={true} showOpenButton={false} onClose={this.addPolicyCallback}
      emailTemplate={this.state.emailTemplate} copiedVersion={this.state.copiedVersion} onSubmit={this.onSubmitCallback}/>;

    const{datasets, activeTab} = this.state;
    const activeData = datasets[activeTab].data;
    const activeConfig = datasets[activeTab].config;

    return (
      <Fragment>
        {!this.props.componentsOnly && <PageTitle
          heading={t("email_template.title")}
          icon={<PhishingIcon name="templates" />}
        />}
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col>
              <Card className="main-card mb-3">
                <CardBody>
                <EmailTemplateModal onSubmit={this.onSubmitCallback} onClose={this.addPolicyCallback} />
                  {editEmailTemplate}
                  {this.state.errorFetchingData ? <Alert color="danger">
                  {this.state.error}
                  </Alert>:<div className="mt-3">
                  <Nav tabs>
                    <NavItem>
                      <NavLink className={classnames({ active: this.state.activeTab == '1' })} onClick={() => this.toggleTab('1')}>My Templates</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: this.state.activeTab == '2' })} onClick={() => this.toggleTab('2')}>Other Templates</NavLink>
                    </NavItem>
                  </Nav>
                  {String(activeTab) === '2' && !this.props.componentsOnly ? <TemplateGallery kind="message" items={activeData}
                    loading={datasets[activeTab].loading} error={datasets[activeTab].error}
                    onRetry={() => this.loadEmailTemplateList('2')}
                    onImported={() => { this.onSubmitCallback(); this.toggleTab('1'); }} /> : activeData ?
                    <PhishingDataTable key={activeTab} config={activeConfig}  data={activeData} onEditOrCopy={this.onEditOrCopyCallback} onDelete={this.deleteEmailTemplate}/>
                    : datasets[activeTab].error ? <Alert color="danger">{datasets[activeTab].error}
                      <Button color="link" onClick={() => this.loadEmailTemplateList()}>Retry</Button>
                    </Alert> : <div><Spinner color="primary" /> Data is loading!!!</div>}
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
    )
  }
  toggleTab(tabActivatedNum) {
    const tab = String(tabActivatedNum);
    this.setState({activeTab: tab}, () => {
      if (!this.state.datasets[tab].data) this.loadEmailTemplateList(tab);
    });
  }
}
export default withTranslation()(EmailTemplate);
